module.exports = __webpack_public_path__ + "img/samsung_step2.ecf340e5.png";